<template>
    <div>
        <div style="height: 100%">
            <div v-if="withSupportLink" class="d-none d-md-block mb-1">
                <span class="ml-1" style="font-size: 0.7rem; color: #a5a5a5;">
                    <a @click="$emit('support-clicked')" class="bLink">
                        <i class="fas fa-headset"></i> Support
                    </a>
                </span>
            </div>

            <!-- Whatever the parent has in the inner content of the ScarlettFooter component -->
            <slot></slot>

            <div class="ml-auto mr-1" style="font-size: 0.8rem;">
                <span style="font-weight: 500;">
                    <img :src="imgLogoFooter" style="height: 14px; margin-right: 3px; padding-top: 2px;" />
                    Scarlett Network {{$t('labels.By')}} Axiom Innovations
                </span>
                &copy; {{ new Date().getFullYear() }}
                <!-- <span style="margin-left: 18px; font-size: 0.7rem; color: #a5a5a5;">
                    {{ appVersion }}
                </span> -->
            </div>
        </div>
    </div>
</template>

<script>
// import { Footer as TheFooter } from "@coreui/vue";

export default {
    name: "ScarlettFooter",
    props: {
        withSupportLink: {
            type: Boolean,
            default: true
        },
        appVersion: {
            type: String,
            required: true,
            default: () => process.env.VUE_APP_VERSION,
        },
    },
    data() {
        return {
            imgLogoFooter: null,
        };
    },
    methods: {
        getlogo() {
            this.imgLogoFooter = "/img/scarlett-logo-footer.png";
        },
    },
    created() {
        this.getlogo();
    },
};
</script>
<style scoped>
.bLink {
    cursor: pointer;
    color: #20a8d8 !important;
}

.bLink:hover {
    text-decoration: underline !important;
    color: #20a8d8;
}
</style>